import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

import { AdminLayout } from '@/features/admin'

/** Administration is for administrators only; anyone else gets "This page doesn't exist" (§4.3). */
export const Route = createFileRoute('/_auth/admin')({
  beforeLoad: ({ context }) => {
    if (context.me.user.role !== 'admin') throw notFound()
  },
  component: AdminRoute,
})

function AdminRoute() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  )
}
